import React from "react";
import {CodeComponent} from "../../../../app/components/code/CodeComponent";

export function HashMapRemoveUnhappyFullCaption() {
    return (<div className="captionParagraphs">
        <HashMapRemoveUnhappy1/>
    </div>)
}

export function HashMapRemoveUnhappy1() {
    return (<p>When every <CodeComponent className="codeValue">VALUE</CodeComponent> collides at the same <CodeComponent
        className="codeHash">HASH</CodeComponent>, and the <CodeComponent
        className="codeValue">VALUE</CodeComponent> we want to remove is the last in our sub-collection, we must
        iterate over the entire sub-collection of <CodeComponent>n</CodeComponent> elements in order to find and
        remove the <CodeComponent className="codeValue">VALUE</CodeComponent> we want to delete. Thus, we see a time
        complexity of <CodeComponent>O(n)</CodeComponent>.</p>)
}
